import { render, staticRenderFns } from "./SelfServiceHome.vue?vue&type=template&id=5b44747e"
import script from "./SelfServiceHome.vue?vue&type=script&lang=js"
export * from "./SelfServiceHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports